import { forkJoin, Observable, of, switchMap, map } from 'rxjs';
import { TenantSpaceClass } from '../../../../../models/space/tenant-space.class';
import { OPTIONS, SPRequest } from '../details-overlay/details-overlay.model';
import { Injectable } from '@angular/core';
import { ICanSaveSPSpace, SaveSpaceEvent } from './space-save.service';
import { DefaultSpaceSaveService } from './default-space-save.service';

@Injectable()
export class LeaseSpaceSaveService extends DefaultSpaceSaveService implements ICanSaveSPSpace {
  protected _makeSPRequestObj = (space, spFormValue, requestParams) => {
    const base = super._makeSPRequestObj(space, spFormValue, requestParams);
    if (base.leaseSpace) {
      // Add space_id to identify the floor after fetching the lease
      base.leaseSpace.spaceId = space.lease?.space_id;
    }
    return base;
  };

  protected _doSave = (
    space: TenantSpaceClass,
    spRequestObj: SPRequest,
    floors?: Record<string, any>[]
  ): Observable<any> => {
    return this._getLease$(space.leaseId).pipe(
      switchMap(lease => {
        if (!lease) {
          return of(new SaveSpaceEvent('error', false));
        }
        return this._createAndProcessPayloads(space, spRequestObj, lease, floors);
      })
    );
  };

  private _getLease$(id: number): Observable<Record<string, any> | null> {
    return this.stackingPlanService.getRecord('lease', id).pipe(map(res => res.results?.[0] || null));
  }

  private _createAndProcessPayloads(
    space: TenantSpaceClass,
    spRequestObj: SPRequest,
    lease: Record<string, any>,
    floors?: Record<string, any>[]
  ): Observable<any> {
    const payloads$ = Object.entries(spRequestObj).map(([key, value]) => {
      const { entity, edpMethod, errorMessage, reqClass, entityKey } = OPTIONS[key];
      const { payloads } =
        key === 'leaseSpace'
          ? new reqClass({ ...value, lease }, edpMethod, floors)
          : new reqClass({ ...value, lease }, edpMethod);

      return this.actionsToolbarService
        .updateOverlapFormData(payloads, entity, space[entityKey])
        .pipe(this.actionsToolbarService.errorHandling(errorMessage));
    });

    return forkJoin(payloads$);
  }
}
